import {Capacitor} from "@capacitor/core";
import {PushNotifications} from "@capacitor/push-notifications";
import {openAppStoreIfUpdateFromPushTap} from "@/utils/openAppStoreFromUpdatePushNotification";

let registered = false;

/**
 * Registers `pushNotificationActionPerformed` at module load so taps are handled on cold start
 * before React mounts `useEffect` listeners (otherwise `action: update` can be lost).
 */
export function registerEarlyPushNotificationTapHandlers(): void {
	if (registered || typeof window === "undefined") {
		return;
	}
	if (!Capacitor.isNativePlatform()) {
		return;
	}
	registered = true;
	void PushNotifications.addListener("pushNotificationActionPerformed", (event) => {
		openAppStoreIfUpdateFromPushTap(event);
	});
}
